import Link from '@/compat/link'

export default function DriverError({
  error: _err,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="text-center space-y-4">
        <h2 className="text-xl font-semibold text-text-primary">
          Something went wrong
        </h2>
        <p className="text-text-muted">
          We couldn't load this page. Please try again.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            type="button"
            onClick={reset}
            className="px-4 py-2 bg-brand-primary text-brand-foreground rounded-md hover:opacity-90"
          >
            Try again
          </button>
          <Link
            href="/driver"
            className="px-4 py-2 border border-border-default text-text-primary rounded-md hover:bg-surface-muted"
          >
            Go to dashboard
          </Link>
        </div>
      </div>
    </div>
  )
}
